import { useContext } from "react";
import { withQuery } from "ufo";

import { directusContext } from "~/shared/utils/directus/directus.provider";

export type ImageParams = {
  format?:
    | "jpg"
    | "jpeg"
    | "png"
    | "gif"
    | "webp"
    | "avif"
    | "svg"
    | "bmp"
    | "ico"
    | "tiff";
  height?: number;
  width?: number;
};

type UseDirectusOutput = {
  getDirectusImage: (imageId: ID, params?: ImageParams) => string;
};

const getDirectusImageUrl = (
  cmsPath: string,
  imageId: ID,
  params?: ImageParams,
): string => {
  return withQuery(`${cmsPath}/assets/${imageId}`, params ?? {});
};

export const useDirectus = (): UseDirectusOutput => {
  const context = useContext(directusContext);
  if (!context) {
    throw new Error("Context can't be null, please add directus provider");
  }

  const cmsPath = context.url;
  return {
    getDirectusImage: (imageId, params) =>
      getDirectusImageUrl(cmsPath, imageId, params),
  };
};
